import { render, staticRenderFns } from "./PeripheralTable.vue?vue&type=template&id=1f6ae9fa"
import script from "./PeripheralTable.vue?vue&type=script&lang=js"
export * from "./PeripheralTable.vue?vue&type=script&lang=js"
import style0 from "./PeripheralTable.vue?vue&type=style&index=0&id=1f6ae9fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports